module.exports = __webpack_public_path__ + "img/deez.9427e02c.svg";